import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/security/utilities/auth.service';
import { BroadcastService } from '@app/shared/utilities/shared';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
  private readonly guestModeQueryString  = "guest";
  private guestMode: boolean = false;
  isConnecting = false;
  message = 'Please enter your Username & Password.';
  loginData = { username: '', password: '' };
  private readonly broadcastChannel = this.broadcastService.createChannel("LoginComponent");
  private readonly broadcastLoginEvent = this.broadcastChannel.createEvent("login", () => this.login());

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly broadcastService: BroadcastService
  ) { }

  onSubmit() {
    this.isConnecting = true;
    this.message = 'Connecting to DHS HIS, please wait...';

    this.authService.login(
      this.loginData.username,
      this.loginData.password,
      this.guestMode)
      .subscribe({
        next: () => {
          this.login();
          this.broadcastLoginEvent.post();
        }, error: _ => this.error()
      });
  }

  private login() {
    this.message = 'Welcome back! Setting up your preferences...';
    setTimeout(() => this.router.navigate(['/Home']));
  }

  error() {
    this.message = "Failed, please try again.";
    this.isConnecting = false;
  }
  ngOnInit() {
    this.document.body.classList.add('login-container');
    this.guestMode = this.activatedRoute.snapshot.queryParamMap.has(this.guestModeQueryString);
  }
  ngOnDestroy() {
    this.document.body.classList.remove('login-container');
  }
}
